module.exports = __webpack_public_path__ + "img/color-white.27b1373f.jpg";